import * as account from './modules/account';
import * as dialog from './modules/dialog';
import * as payment from './modules/payment';
import * as character from './modules/character';
import * as gift from './modules/gift';
import * as photoGeneration from './modules/photoGeneration';
import * as survey from './modules/survey';

const reducers = {
  ...account.reducers,
  ...dialog.reducers,
  ...payment.reducers,
  ...character.reducers,
  ...gift.reducers,
  ...photoGeneration.reducers,
  ...survey.reducers,
};

export default reducers;
